import React from 'react'

/**
 * 매뉴얼 화면 아이콘 — Lucide(ISC) 원본 path 그대로, 24 viewBox, strokeWidth 1 (DESIGN_SYSTEM §9).
 * 전부 장식이라 `aria-hidden`. 의미는 버튼의 텍스트·aria-label 이 말한다.
 */
const pathObj = {
	chevronDown: ['m6 9 6 6 6-6'],
	chevronRight: ['m9 18 6-6-6-6'],
	chevronLeft: ['m15 18-6-6 6-6'],
	arrowRight: ['M5 12h14', 'm12 5 7 7-7 7'],
	x: ['M18 6 6 18', 'm6 6 12 12'],
	list: ['M8 6h13', 'M8 12h13', 'M8 18h13', 'M3 6h.01', 'M3 12h.01', 'M3 18h.01'],
}

export type ManualIconNameType = keyof typeof pathObj

interface PropsType {
	name: ManualIconNameType
	size?: number
	className?: string
}

export const ManualIcon = (props: PropsType) => {
	const size = props.size ?? 18
	return (
		<svg
			className={props.className}
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={1}
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			{pathObj[props.name].map(aPath => (
				<path key={aPath} d={aPath} />
			))}
		</svg>
	)
}
